export default __webpack_public_path__ + "static/media/background.1f6c4bfc.svg";